module.exports = __webpack_public_path__ + "static/ex3-c606fad83567aba286585031b7cf4d3a.png";